import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusShellLogo], campus-shell-logo',
})
export class ShellLogoDirective {
  @HostBinding('class.ui-shell__logo') hasUiShellLogoClass = true;
}
